import React, { Component } from 'react';
import { Grid, Typography, Button, Link, Container, Hidden } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import { connect } from "react-redux";
import logoColor from "../../../assets/images/logo-color.png";
import { Redirect } from "react-router-dom";
import StringNumber from '../../common/fields/StringNumber';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

class Validation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            auth_code: null,
            responseStatus: null,
            errors: {
                status: {
                    auth_code: false
                },
                text: {
                    auth_code: ""
                }
            },
            visitorId: null
        };
    }

    async initializeFingerprint() {
        try {
            const fp = await FingerprintJS.load(); // Cargar la librería FingerprintJS
            const result = await fp.get();         // Obtener la información del cliente
            this.setState({ visitorId: result.visitorId }); // Guardar el visitorId en el estado
        } catch (error) {
            console.error("Error initializing FingerprintJS:", error);
        }
    }

    componentDidMount() {
        this.initializeFingerprint(); // Llamar a la función al montar el componente
    }

    // Este método se llama cada vez que las props cambian
    componentDidUpdate(prevProps) {
        if (this.props.status !== prevProps.status) {
            if (this.props.status === 'ok') {
                this.setState({ responseStatus: 'ok' });  // Acción cuando la respuesta es 'ok'
            }
        }

        if (this.props.errorLoginToken !== prevProps.errorLoginToken) {
            // Maneja el caso cuando el error en el token cambia
            if (this.props.errorLoginToken) {
                this.setState({ errors: { ...this.state.errors, status: { auth_code: true }, text: { auth_code: "Código incorrecto" } } });
            }
        }
    }

    send = async () => {
        let form = {};
        let countValid = 0;
        let errors = [];

        if (this.state.visitorId) {
            countValid++;
            form.visitor = this.state.visitorId;
        }

        if (this.state.auth_code && this.state.auth_code !== null) {
            if (this.state.auth_code.state.defaultValue !== '') {
                countValid++;
                form[this.state.auth_code.props.name] = this.state.auth_code.state.defaultValue;
            }
        }

        errors = {
            status: {
                auth_code: (this.state.auth_code && this.state.auth_code.state.defaultValue !== '' && this.state.auth_code.state.errorText === '') ? false : true,
            },
            text: {
                auth_code: (this.state.auth_code && this.state.auth_code.state.defaultValue !== '' && this.state.auth_code.state.errorText === '') ? "" : "Ingrese su código",
            }
        }
        this.setState({ errors: errors });

        if (countValid === 2) {
            this.props.authenticateToken(form);
        }
    }

    render() {
        return (
            this.state.responseStatus === 'ok' ? 
                (<Redirect to={"/dashboard"} exact />) :
                <Container maxWidth="md" className="mx-auto">
                    <div className="login_container">
                        <Hidden mdUp>
                            <img alt="logo" src={logoColor} className="logo" />
                        </Hidden>

                        <div className="form-header">
                            <Typography component="h1" variant="h4" className="title">Necesitamos validar tu usuario</Typography>
                            <Typography component="h2" variant="h5" className="subtitle">Ingresa el código que recibiste en tu correo para continuar.</Typography>
                        </div>

                        <form className="form" noValidate>
                            <Grid container spacing={1}>
                                <Grid item md={6}>
                                    <StringNumber
                                        ref={element => { this.state.auth_code = element }}
                                        id="auth_code"
                                        label="Código"
                                        name="auth_code"
                                        placeholder="Ingrese su código"
                                        defaultValue={''}
                                        disabled={false}
                                        error={this.state.errors.status.auth_code}
                                        errorText={this.state.errors.text.auth_code}
                                        classNameCustom={'textField'}
                                        autoComplete="Código"
                                        required={true}
                                        handleError={true}
                                    />
                                </Grid>
                            </Grid>

                            {this.props.status === 'ko' && (
                                <>
                                    <Alert severity="error">
                                        <AlertTitle>Error</AlertTitle>
                                        {this.props.errorLoginToken ? (
                                            this.props.messageToken
                                        ) : (
                                            'No es posible validar el usuario en este momento. Por favor, inténtelo nuevamente en unos minutos'
                                        )}
                                    </Alert>
                                    <br />
                                </>
                            )}

                            <div>
                                <Button
                                    component={Link} href={'/login'}
                                    variant="text"
                                    className="mr-1"
                                    size="large"
                                >Ingresar con otra cuenta</Button>

                                <Button
                                    onClick={() => this.send()}
                                    variant="contained"
                                    color="primary"
                                    className="submit"
                                    size="large"
                                >
                                    Enviar
                                </Button>
                            </div>
                        </form>
                    </div>
                </Container>
        );
    }
}

const mapStateToProps = reducers => {
    return reducers.loginReducer;
};

const mapDispatchToProps = dispatch => {
    return {
        authenticateToken: (data) => dispatch({ type: "AUTHENTICATE_TOKEN", data }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Validation);